import type { ComponentPublicInstance, Ref } from 'vue';
import { toValue } from 'vue';

export type MaybeElement<T> = T | ComponentPublicInstance | null | undefined;

export const unwrapElement = <T extends HTMLElement>(
  ref: Readonly<Ref<MaybeElement<T>>> | null | undefined,
): Exclude<MaybeElement<T>, ComponentPublicInstance> => {
  const value = toValue(ref);

  return (value as Exclude<MaybeElement<T>, T>)?.$el ?? value;
};
